import React from "react";
import { Alert, Typography } from "antd";
import { Modal } from "../../components/Common";

const { Text, Paragraph } = Typography;

/**
 * Shows a freshly issued set of recovery codes. Only their hashes reach the database,
 * so this dialog is the one and only chance to write them down — the same contract as
 * CredentialsModal, and for the same reason.
 */
const RecoveryCodesModal = ({ codes, onClose }) => (
  <Modal
    open={Boolean(codes?.length)}
    onClose={onClose}
    title="Your recovery codes"
    cancelText="I have saved them"
    maskClosable={false}
    size="sm"
  >
    <Alert
      type="warning"
      showIcon
      style={{ marginBottom: 16 }}
      message="Save these codes now"
      description="Each one signs you in once if you lose your phone. They are stored only as hashes and cannot be shown again — generating a new set replaces them all."
    />

    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 8,
        padding: 16,
        borderRadius: 8,
        background: "rgba(128,128,128,0.08)",
      }}
    >
      {(codes || []).map((code) => (
        <Text key={code} code style={{ fontSize: 14, letterSpacing: 1 }}>
          {code}
        </Text>
      ))}
    </div>

    <Paragraph style={{ marginTop: 16, marginBottom: 0 }}>
      <Text copyable={{ text: (codes || []).join("\n") }} type="secondary">
        Copy all codes
      </Text>
    </Paragraph>
  </Modal>
);

export default RecoveryCodesModal;
